module.exports = __webpack_public_path__ + "img/icon-rocket.7351c62c.svg";